import { Camera } from 'lucide-react'
import { GUEST_ALBUM_URL } from '../content/latest-update-promo'

export function GuestAlbum() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-primary-100 rounded-full p-4">
            <Camera className="h-10 w-10 text-primary-600" />
          </div>
        </div>
        <h1 className="text-3xl font-serif text-gray-900 mb-2">Share Your Photos</h1>
        <p className="text-gray-600 mb-6">
          Help us capture every moment! Add your photos and videos to our shared wedding album on Google Photos.
        </p>
        <a
          href={GUEST_ALBUM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-full transition-colors duration-200"
        >
          Open Shared Album
        </a>
        <p className="text-sm text-gray-400 mt-6">
          No Google account? You can still view photos — just tap the link above.
        </p>
      </div>
    </div>
  )
}
